<template>
  <div v-if="models.length > 1" class="carousel-models-wrapper">
    <div class="wrapper">
      <p class="fs-36 color-black bold">
        {{ trans['find_best'] }}
      </p>
      <div class="carousel-models">
        <flickity ref="flickity" :options="flickityOptions">
          <div v-for="model in models" :key="model.id" class="carousel-cell">
            <div class="item">
              <div class="text-wrap">
                <p class="title">{{ model.model }}</p>
                <div class="text" v-html="model['carousel_description']"></div>
                <p class="price">from {{ $crConverter(model.price / 100, 'EUR') }}</p>
                <a v-if="model.purchasable" :href="`/en/choose/${model.slug}`" class="btn btn-green" target="_blank">{{ trans['buy'] }}</a>
                <a :href="`/en/products/${model.slug}`" class="btn btn-arr" target="_blank">
                  {{ trans['learn_more'] }}
                  <svg
                      fill="none"
                      height="12"
                      viewBox="0 0 8 12"
                      width="8"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M0.999999 11.4531L6 6.45313L1 1.45312"
                        stroke="black"
                        stroke-width="1.5"
                    />
                  </svg>
                </a>
              </div>
              <div class="img-wrap">
                <picture>
                  <source
                      :srcset="model['slider_img']"
                      media="(max-width: 991px)"
                  />
                  <img
                      :src="model['slider_img']"
                      class="picture"
                      alt=""/>
                </picture>
              </div>
            </div>
          </div>
        </flickity>
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'ModelsCarousel',
  props: ['models', 'trans'],
  components: {
    "flickity": Flickity,
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        cellAlign: 'left',
        percentPosition: true,
        contain: true,
        on: {
          staticClick: function (event, pointer, cellElement, cellIndex) {
            if (typeof cellIndex == 'number') {
              this.selectCell(cellIndex);
            }
          },
        }
      },
    }
  },
}
</script>

<style lang="scss">
.carousel-models-wrapper {
  overflow: hidden;

  * {
    user-select: none;
  }

  .fs-36 {
    margin: 0 0 45px;
  }

  .flickity-slider {
    //margin-left: calc((100vw - 1158px) / 2);
  }

  .flickity-viewport {
    overflow: visible;
  }

  .carousel-cell {
    margin-right: 10px;
    overflow: hidden;
    border-radius: 25px;
    opacity: 0.5;
    -webkit-clip-path: content-box;
    clip-path: content-box;

    &.is-selected {
      opacity: 1;
    }

    .item {
      overflow: hidden;
      border-radius: inherit;
      width: 890px;
      background: #f9f9f9;
      padding: 56px;
      position: relative;

      transition: 0s;

      &:hover {
        .picture {
          transform: scale(1.03);
        }
      }

      .picture {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 100%;
        max-width: 100%;
        object-fit: cover;
        transition: 0.3s;
      }

      .text-wrap {
        max-width: 324px;
        position: relative;
        z-index: 2;
      }

      .title {
        font-weight: bold;
        font-size: 42px;
        line-height: 1.1;
        color: #1c1c1c;
        margin: 0 0 10px;
      }

      .text {
        font-size: 17px;
        line-height: 25px;
        color: #474747;
        margin: 0 0 19px 0;
        height: 75px;
        overflow: hidden;

        p {
          margin: 0 0 8px;
          font-size: inherit;
          line-height: inherit;
          color: inherit;
        }
      }

      .price {
        font-weight: bold;
        font-size: 20px;
        line-height: 1.1;
        color: #1c1c1c;
        margin: 0 0 14px;
      }

      .btn.btn-green {
        border-radius: 7px;
        width: 174px;
        height: 40px;
        line-height: 1;
        display: flex;
        margin-bottom: 42px;
      }
    }
  }

  .flickity-page-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    margin: 45px 0 0;
    bottom: 0;

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: #c4c4c4;
      display: block;
      margin: 0 7px;
      border: none;
      opacity: 1;

      &:after {
        display: none;
      }

      &.is-selected {
        background-color: #c2e900;
      }
    }
  }

  @media (max-width: 1300px) {
    //.flickity-slider {
    //  margin-left: calc((100vw - 1020px) / 2);
    //}

    .carousel-cell .item {
      width: 700px;
    }
  }
  //@media (max-width: 1060px) {
  //  .flickity-slider {
  //    margin-left: 20px;
  //  }
  //}
  @media (max-width: 991px) {
    .fs-36 {
      margin: 0 0 35px;
    }
    .carousel-cell {
      opacity: 1;
      border-radius: 0;
      margin-right: 30px;

      .item {
        width: 374px;
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        background-color: transparent;
        border-radius: 0;

        .img-wrap {
          order: 1;
          width: 100%;
          position: relative;
          padding-top: 90%;
          margin-bottom: 30px;
          background-color: #f9f9f9;
        }

        .text-wrap {
          order: 2;

          .title {
            font-size: 24px;
          }

          .text {
            font-size: 12px;
            line-height: 18px;
            height: 54px;
          }

          .btn.btn-green {
            margin: 0;
          }

          .btn.btn-arr {
            display: none;
          }
        }
      }
    }
    .flickity-page-dots {
      margin-top: 32px;
    }
  }
  @media (max-width: 767px) {
    .fs-36 {
      margin: 0 0 30px;
    }
    .carousel-cell {
      margin-right: 20px;

      .item {
        width: 294px;

        .img-wrap {
          margin-bottom: 26px;
        }
      }
    }
  }
  @media (max-width: 350px) {
    .carousel-cell {
      .item {
        width: 240px;
      }
    }
  }
}
</style>
